<div class="item-container d-flex flex-column ">
    <div class="item-header pb-3">
        <h6 class="text-center mb-0">{{"COMMON.ADD" | translate}} {{"COMMON.FORMFIELD" | translate}}</h6>
        <div class="edit-icons cursor-pointer" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-grow-1">
    <form class="flex-grow-1 d-flex flex-column">
            <div class="row h-100">
                <div class="col-md-6 col-lg-5 b-cont d-flex flex-column justify-content-center">
                    <div class="i-b-cont d-flex flex-wrap justify-content-center">
                        <div class="i-box d-flex flex-column justify-content-center align-items-center"
                            [ngClass]="item.selected ? 'active-box':''" *ngFor="let item of formElementArr"  (click)="onBoxClick(item)">
                            <div class="b-img">
                                <img [src]="item.img" class="img-fluid">
                            </div>
                            <div class="b-text mt-2">{{item.name}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-7 b-r-cont px-xl-5">
                    <h6 class="py-3 py-xl-4 mb-0">{{selectedElement.title}}</h6>
                    <div *ngIf="selectedElement.type=='description'">
                        <quill-editor [styles]="{width: '100%'}" class="d-block" [(ngModel)]="selectedElement.desc" [ngModelOptions]="{standalone: true}"></quill-editor>
                        <mat-error *ngIf="(selectedElement.desc=='' || (selectedElement.desc==null))&& isError">{{"COMMON.THR" |translate}}  </mat-error>
                    </div>
                    <div *ngIf="selectedElement.type!='description'">
                        <label for="">{{"COMMON.QUESTION"|translate}}</label>
                        <input type="text" class="form-control" placeholder="{{'COMMON.TYQ' |translate}} " name="question"  [(ngModel)]="selectedElement.su_q">
                        <div>  <mat-error *ngIf="(selectedElement.su_q=='')&& isError">{{"COMMON.THR" |translate}}  </mat-error></div>
                      
                        <label for="" class="mt-3">{{"COMMON.DESC"|translate}}</label>
                        <input type="text" class="form-control" placeholder="{{'COMMON.DESC'|translate}}({{'COMMON.OPTIONAL'|translate}})" name="question description"  [(ngModel)]="selectedElement.desc">                        
                    </div>
                    <div *ngIf="selectedElement.type=='rating'">
                        <div class="border-class mb-4"></div>
                        <h6 class="pb-3 pb-xl-4 mb-0">{{"MENUITEMS.STAFFSURVEY.CHOSESTARS" | translate}}</h6>
                        <div class="s-box d-flex flex-wrap">
                            <div class="s-item mt-2 mt-sm-0">{{"COMMON.VERYBAD" | translate}}</div>
                            <div class="s-item mt-2 mt-sm-0">
                                <div class="row w-100 h-100">
                                    <div class="col-3 cursor-pointer d-box" (click)="onStartCountClick('sub')">-</div>
                                    <div class="col-6 s-n  d-box flex-row">{{starCount}} <i
                                            class="material-icons ps-2">star</i></div>
                                    <div class="col-3 cursor-pointer d-box " (click)="onStartCountClick('add')">+</div>
                                </div>
                            </div>
                            <div class="s-item me-0 mt-2 mt-sm-0">{{"COMMON.VERYGOOD" | translate}}</div>
                        </div>                        
                    </div>
                    <div *ngIf="selectedElement.type=='numeric_range'">
                        <div class="border-class mb-4"></div>
                        <h6 class="pb-3 pb-xl-4 mb-0">{{"MENUITEMS.STAFFSURVEY.RANGEVALUES" | translate}}</h6>
                        <div class=" d-flex flex-wrap align-items-center">
                            <div><input class="form-control m-box" type="number" placeholder="{{'COMMON.MINVALUE' | translate}}" [(ngModel)]="selectedElement.min"
                                [ngModelOptions]="{standalone: true}"></div>
                             
                            <div class="mx-3">{{"COMMON.TO" | translate}}</div>
                            <div>
                                <input class="form-control m-box" type="number" placeholder="{{'COMMON.MAXVALUE' | translate}}"[(ngModel)]="selectedElement.max"
                                [ngModelOptions]="{standalone: true}"></div>
                        </div>  
                        <mat-error *ngIf="((selectedElement.min > selectedElement.max)||(selectedElement.min < 0) ||(selectedElement.max < 0)
                            ||(selectedElement.min == '') ||(selectedElement.max == '')   )&& isError">
                            {{"VALIDATION.VALIDRANGE" |translate}}  </mat-error>                          
                    </div>
                    <div *ngIf="selectedElement.type=='dropdown'">
                        <h6 class="pt-3 pt-xl-4 mb-0">{{"COMMON.ITEM" | translate}}</h6>
                        <div class="item-c  d-flex align-items-center mt-3 " *ngFor="let item of selectOptionArr;let i=index" [ngClass]="{'slide-out': item.slideOut}" >
                            <div class="drag-img me-3 d-none d-sm-flex flex-column">
                                <img src="assets/images/icons/drag_drop.png" class="img-flutype" alt="">
                            </div>
                            <input type="text" class="form-control flex-grow-1"  [(ngModel)]="item.val" [ngModelOptions]="{standalone: true}">
                            <div class="action-icon ms-3 del-icon " (click)="onDeleteItem(i)" >
                                <i class="material-icons">delete</i>
                            </div>
                        </div>
                        <mat-error *ngIf="(selectedElement.isOptionErr==true)&& isError">{{errorMsg}}  </mat-error>
                        <div class="add-text mt-3 cursor-pointer" (click)="onAddItem()"
                         *ngIf="selectOptionArr.length <10"><i class="material-icons">add</i> {{"COMMON.ADD" | translate}} {{"COMMON.FIELD" | translate}}</div>
                    </div>
                    <div *ngIf="selectedElement.type!='description'">
                        <div class="border-class mb-4"></div>
                        <mat-checkbox name="agree" [(ngModel)]="selectedElement.i_r" [ngModelOptions]="{standalone: true}">
                            <div class="text-wrap">Required</div>
                        </mat-checkbox>
                    </div>
                </div>
            </div>

    </form>
</div>
    <div class="item-footer">
        <div class="d-flex justify-content-end align-items-center ">
            <button type="button" (click)="onCancel()"
                class="auth-form-btn outline-btn new-outline d-flex align-items-center justify-content-center mt-3 me-3 mb-2 mb-xxl-0">{{"BUTTON.CANCEL" |translate}}</button>
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mb-2 mb-xxl-0" (click)="onSave()" type="submit">
                {{"BUTTON.SAVE"|translate}}</button>
        </div>
    </div>
</div>

